export default defineNuxtPlugin((nuxtApp) => {
  console.log('Test')
  const isBrowserIncompatible = ref(false);
  const requirements = {
    // Core CSS Properties - Well supported across modern browsers
    cssProperties: [
      "aspect-ratio",  // Essential for your app
      "display",       // For flex/grid
      "position",      // For layout
      "grid",         // Basic grid
      "flex",         // Basic flexbox
      "gap",          // Spacing in flex/grid
      "transform",    // Transforms
      "transition"    // Basic animations
    ],

    // Essential CSS Values - Universally supported
    cssValues: [
      { prop: "width", value: "calc(100% - 10px)" },   // Basic calc
      { prop: "color", value: "rgba(0, 0, 0, 0.5)" },  // Basic color with alpha
      { prop: "color", value: "hsl(0, 0%, 0%)" },      // HSL colors
      // Test aspect-ratio with a specific value
      { prop: "aspect-ratio", value: "16/9" }          // Common aspect ratio
    ],

    // Core JS Features - Essential modern JavaScript
    jsFeatures: [
      "Promise.allSettled",    // Promise handling
      "globalThis",            // Global scope
      "optional-chaining",     // Safe property access
      "nullish-coalescing"     // Null checking
    ]
  };

  const incompatibleFeatures = [];

  // Check media query support - fundamental for responsive design
  if (!window.matchMedia) {
    incompatibleFeatures.push("@media queries not supported");
  }

  // Check CSS Properties
  requirements.cssProperties.forEach(property => {
    try {
      if (!CSS.supports(property, "initial")) {
        incompatibleFeatures.push(property);
      }
    } catch {
      incompatibleFeatures.push(property);
    }
  });

  // Check CSS Values
  requirements.cssValues.forEach(({ prop, value }) => {
    try {
      if (!CSS.supports(prop, value)) {
        incompatibleFeatures.push(`${prop}: ${value}`);
      }
    } catch {
      incompatibleFeatures.push(`${prop}: ${value}`);
    }
  });

  // Check JS Features
  requirements.jsFeatures.forEach(feature => {
    try {
      switch (feature) {
        case "Promise.allSettled":
          if (typeof Promise.allSettled !== "function") throw new Error();
          break;
        case "globalThis":
          if (typeof globalThis === "undefined") throw new Error();
          break;
        case "nullish-coalescing":
          eval("const test = null ?? 'default'");
          break;
        case "optional-chaining":
          eval("const test = {}.optional?.chaining");
          break;
      }
    } catch {
      incompatibleFeatures.push(feature);
    }
  });

  isBrowserIncompatible.value = incompatibleFeatures.length !== 0;
  console.log("TEST RULES FROM PLUGIN: ", isBrowserIncompatible.value, incompatibleFeatures);

  return {
    provide: {
      isBrowserIncompatible: isBrowserIncompatible.value
    }
  };
});